import { useBackground } from "../context/BackgroundContext";
import { Outlet, useLocation } from "react-router-dom";
import { useSettings } from "../hooks/useSettings";
import useOrientation from "../hooks/useOrientation";
import useDeviceType from "../hooks/useDeviceType";
import { API_BASE_URL } from "../config/api";
export default function AppLayout() {

  const location = useLocation();
  const { settings } = useSettings();
  const orientation = useOrientation();

  const pagePath = location.pathname;

  const isLandscape = orientation === "landscape";

  let pathBackground = null;

  const homePages = ["/", "/contacts", "/arcade"];
  const isProduct = pagePath.startsWith("/product/");

  if (homePages.includes(pagePath)) {

    pathBackground = isLandscape
      ? settings?.desktopBackgroundPath
      : settings?.mobileBackgroundPath;

  } else if (isProduct) {

    pathBackground = isLandscape
      ? settings?.desktopDetailsBackgroundPath ?? settings?.desktopBackgroundPath
      : settings?.mobileDetailsBackgroundPath ?? settings?.mobileBackgroundPath;

  } else {

    pathBackground = isLandscape
      ? settings?.desktopGalleryBackgroundPath ?? settings?.desktopBackgroundPath
      : settings?.mobileGalleryBackgroundPath ?? settings?.mobileBackgroundPath;

  }

  const absolutePath = pathBackground
    ? API_BASE_URL + pathBackground
    : null;

  return (
    <div
      className="app-wrapper"
      style={{
        position: "relative",
        minHeight : '100vh'
      }}
    >
      <div
        className="app-background"
        style={{
          backgroundImage: absolutePath ? `url(${absolutePath})` : "none",
          position: "fixed",
          inset: 0,
          width: "100%",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          pointerEvents: 'none'
        }}
      />

      <Outlet />

    </div>
  );
}